import { render } from "./ResendDocumentPrint.vue?vue&type=template&id=00bb8749&scoped=true"
import script from "./ResendDocumentPrint.vue?vue&type=script&lang=js"
export * from "./ResendDocumentPrint.vue?vue&type=script&lang=js"

import "./ResendDocumentPrint.vue?vue&type=style&index=0&id=00bb8749&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bb8749"]])

export default __exports__